module.exports = __webpack_public_path__ + "static/media/call-icon.54f0a9ac.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/call-icon.svg
// module id = 1849
// module chunks = 0